<div class="report-wrapper">
  <div class="header">
    <img src="/img/Parent@2x.png" class="header-image">
    <div class="contact-info">
      <div style="font-weight:600">Royal New York</div>
      <div>661 Hadley Rd.</div>
      <div>South Plainfield, NJ 07080</div>
      <div>Phone: (908) 756-6400</div>
    </div>
    <h3>Delivery Order</h3>
  </div>
  <hr />
  @if (Header) {
  <fieldset style="width:95%">
    <legend style="font-size:16px; font-weight:bold">Order # {{Header.OrderID}}</legend>
    <div class="order-information">
      <div class="data-column">
        <div class="data"><div>Customer:</div><div>{{Header.CompanyName}}</div></div>
        <div class="data"><div>Warehouse:</div><div>{{Header.WarehouseName}}</div></div>
        <div class="data"><div>Warehouse Address:</div><div>{{Header.LocationStreet}}, {{Header.LocationCity}}, {{Header.LocationState}}</div></div>
        <div class="data"><div>Pickup Date:</div><div>{{Header.PickupDate | date:'MM-dd-yyyy':'UTC'}}</div></div>
      </div>
      <div class="data-column">
        <!-- 5.2.13: no Bill To section — intentionally omitted -->
        <div class="data"><div>Ship To:</div><div>{{Header.ShipToStreet}}</div></div>
        <div class="data"><div>City/State/Zip:</div><div>{{Header.ShipToCity}}, {{Header.ShipToState}} {{Header.ShipToZip}}</div></div>
      </div>
    </div>
  </fieldset>

  <fieldset style="width:95%">
    <legend style="font-size:14px; font-weight:bold">Items</legend>
    <table style="width:100%">
      <thead><tr><th style="text-align:left">Item</th><th style="text-align:left">Bags</th></tr></thead>
      <tbody>
        @for (item of LineItems; track item.InventoryID) {
        <tr><td>{{item.InventoryID}} · {{item.InventoryTypeName}}</td><td>{{item.TotalBags}}</td></tr>
        }
      </tbody>
    </table>
  </fieldset>

  <fieldset style="width:95%">
    <legend style="font-size:14px; font-weight:bold">Warehouse Instructions</legend>
    <div>{{Header.WarehouseInstructions}}</div>
  </fieldset>
  }

  <div class="footer">
    <div style="font-size:10px; color:#888">This is a system-generated delivery order retained for record-keeping purposes. Order #{{Header?.OrderID}}.</div>
  </div>
</div>
